export default __webpack_public_path__ + "static/media/institution_logo.27e92b83.png";